/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminFhirCleanupOrganizationFhirIdDelete$Params {
  fhirId: string;
}

export function adminFhirCleanupOrganizationFhirIdDelete(http: HttpClient, rootUrl: string, params: AdminFhirCleanupOrganizationFhirIdDelete$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminFhirCleanupOrganizationFhirIdDelete.PATH, 'delete');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as OrganizationStrictHttpResponse<void>;
    })
  );
}

adminFhirCleanupOrganizationFhirIdDelete.PATH = '/Admin/fhir-cleanup/organization/{fhirId}';
